import { render, staticRenderFns } from "./SrCheckbox.vue?vue&type=template&id=f06369c4&scoped=true"
import script from "./SrCheckbox.vue?vue&type=script&lang=js"
export * from "./SrCheckbox.vue?vue&type=script&lang=js"
import style0 from "./SrCheckbox.vue?vue&type=style&index=0&id=f06369c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06369c4",
  null
  
)

export default component.exports